<div class="flex flex-col items-center gap-2 w-full">
  <p class="font-hand text-[12pt] leading-none text-center text-heat">{{ dateLabel() }}</p>
  <button type="button" class="hh-btn bg-heat text-white border-0 text-lg w-full" (click)="select()">
    <span class="truncate">{{ title() }}</span>
  </button>
</div>
